import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, useTheme } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FooterWrapper, InfoLine } from './Atoms';

const messages = {
  PROGRESS:
    'Bij sommige oefeningen kunnen we niet meten of ze afgewerkt zijn. Daarom verschilt het aantal oefeningen bij ‘progressie’ soms van het totaal aantal oefeningen in de reeks.',
  SCORE:
    'Je gemiddelde score houdt alleen maar rekening met de oefeningen die we kunnen meten én bovendien al afgewerkt zijn.',
};

type Props = {
  progressAndScore: ProgressAndScore;
};

type ProgressAndScore = {
  progress: string;
  score: string;
};

const SeriesCardScoresAndProgressInfo: FC<Props> = ({ progressAndScore }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <FooterWrapper>
      <InfoLine>
        <Tooltip arrow title={messages.PROGRESS} placement="right">
          <InfoLine>
            <FontAwesomeSpriteIcon
              iconSize="xs"
              icon={SpriteIconsLight.PROGRESS}
              color={theme.palette.secondary.main}
            />
            <span>{`${t('progressAndScores.series.progress')}: ${progressAndScore.progress}`}</span>
            <FontAwesomeSpriteIcon
              iconSize="xs"
              icon={SpriteIconsLight.INFO}
              color={theme.palette.secondary.main}
            />
          </InfoLine>
        </Tooltip>
      </InfoLine>
      <InfoLine>
        <Tooltip arrow title={messages.SCORE} placement="right">
          <InfoLine>
            <FontAwesomeSpriteIcon
              iconSize="xs"
              icon={SpriteIconsLight.PROGRESS_AND_SCORES}
              color={theme.palette.secondary.main}
            />
            <span>{`${t('progressAndScores.series.score')}: ${progressAndScore.score}`}</span>
            <FontAwesomeSpriteIcon
              iconSize="xs"
              icon={SpriteIconsLight.INFO}
              color={theme.palette.secondary.main}
            />
          </InfoLine>
        </Tooltip>
      </InfoLine>
    </FooterWrapper>
  );
};

export default SeriesCardScoresAndProgressInfo;
